import { Field, useFormikContext } from "formik";
import React, { FC, useRef } from "react";
import { useLocale } from "../../contexts/localeContext";
import useFocusOnRouteChange from "../../hooks/useFocusOnRouteChange";
import { requiredValidation } from "../../utilities/Validation";
import Label from "../label/label";
import { TranslationKeys } from "../../contexts/TranslationKeys";

export const AccessProfileCard:FC = ()  => {
    const { errors, values } = useFormikContext<any>();
    const inputRef = useRef<HTMLInputElement>(null);
    const { translate } = useLocale();

    useFocusOnRouteChange(inputRef);

    return <div className="w-full p-2 inline-flex justify-start items-center bg-white">
        <div className="ml-8 mr-5  card-details">
            <div
                className="text-1xl text-portal-blue-primary-shade2 font-bold text-ellipsis bound-title"
                title={values.name}>{values.name}</div>
        </div>
        <div className="flex flex-col py-4 px-8">
            <div className="mb-2">
                <div className="flex flex-row justify-between" id='nameLabel'>
                    <Label
                        htmlFor="name"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                    {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                </div>

                <div className="flex flex-row justify-between">
                    <Field
                        type="text"
                        name="name"
                        id="nameInput"
                        innerRef={inputRef}
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                        validate={(value) => requiredValidation(value, translate)} />
                </div>
            </div>
        </div>
    </div>
}